import { MESSAGES } from 'src/modules/common/constants.ts';
import { getProductUrl } from 'src/utils/getProductUrl.ts';
import { ActuatorAccessoriesPageData } from 'src/actuators/accessories/ActuatorAccessoriesPageMapping.ts';
import { SensorProduct } from 'src/sensors/list/SensorsPageMapping.ts';
import { CheckoutPageData, ComboData } from 'src/modules/checkout/CheckoutPageMapping.ts';
import { Accessory } from 'src/common/prepareAccessories.ts';
import { SensorsAccessoriesPageData } from 'src/sensors/accessories/SensorsAccessoriesPageMapping.ts';
import { AttributesListItemMulti } from 'src/utils/createAttributesItem.ts';
import { UserSettings } from 'src/types/UserSettings.ts';

type Product = ActuatorAccessoriesPageData['accessories']['actuator'] |
SensorProduct | ComboData;

type Accessories = Accessory<
ActuatorAccessoriesPageData['accessories']['accessories']['0'] |
SensorsAccessoriesPageData['accessories']['accessories']['0'] |
CheckoutPageData['vssAccessories']['valveAccessories']['0']
>[]

export const shapeSelectionExportTable = ({
    attr,
    product,
    accessories,
    locationState,
    userSettings,
}: {
    userSettings: UserSettings;
    attr: AttributesListItemMulti[];
    product: Product;
    accessories: Accessories;
    locationState: { qty: number };

}) => ({
    columns: [
        MESSAGES.exportExcelMaterial,
        MESSAGES.exportExcelQuantity,
        ...attr.map(([key]) => key),
        MESSAGES.Description,
    ],
    rows: [
        [
            {
                text: product.Label,
                hyperlink: getProductUrl({
                    countryDomain: userSettings.countryDomain,
                    currentLocale: userSettings.currentLocale,
                    label: product.Label,
                }),
            },
            String(locationState.qty),
            ...attr.map(([, value]) => value),
        ],
        ...accessories.map((p) => [
            { text: p.accessory.item.Label,
                hyperlink: getProductUrl({
                    countryDomain: userSettings.countryDomain,
                    currentLocale: userSettings.currentLocale,
                    label: p.accessory.item.Label,
                }) },
            String(p.qty),
            ...attr.map(() => ''),
            p.accessory.item.description,
        ]),
    ],
});
